module.exports = __webpack_public_path__ + "static/media/safe.89fbbf96.png";